module.exports = __webpack_public_path__ + "static/crater-founders-grid-1-b93769bc1e1c35572ec37b5a08e15790.png";